export default __webpack_public_path__ + "static/media/eight.6b010483.jpeg";